import React from "react";

export interface PillProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: "neutral" | "primary" | "accent" | "success" | "danger" | "locked";
  size?: "sm" | "md";
  icon?: React.ReactNode;
}

/** One chip style for tags, badges and locked states. */
export default function Pill({ tone = "neutral", size = "md", icon, className = "", children, ...rest }: PillProps) {
  return (
    <span className={`mr-pill mr-pill--${tone} mr-pill--${size} ${className}`} {...rest}>
      {icon ? <span className="mr-pill__icon" aria-hidden="true">{icon}</span> : null}
      {children}
    </span>
  );
}
